module.exports = __webpack_public_path__ + "assets/img/cardList-header.a702fd31.png";